export default function verificarNomeDsp(colunaSimcard, id) {
  let nome = false
  colunaSimcard.forEach((item) => {
    if (item.id === id) {
      nome = item.nome
    }
  })
  return nome
}
